import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ role, allowedModules }) => {
  const location = useLocation();
  const currentPath = location.pathname.replace("/", "").toLowerCase();

  if (role === "Admin") return <Outlet />;

  if (currentPath === "dashboard") return <Outlet />;
  const isAllowed = allowedModules.some((module) => {
    const modulePath = module.toLowerCase();
    return (
      currentPath === modulePath ||
      currentPath.startsWith(modulePath.split("/")[0] + "/")
    );
  });

  return isAllowed ? (
    <Outlet />
  ) : (
    <Navigate to="/error" state={{ error: "Unauthorized Access" }} />
  );
};

export default ProtectedRoute;
